import React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from 'primereact/button';

import { IntegrationSettings } from '../../models/integrationSettings';
import { IntegrationStatus, IntegrationVendor } from '../../models/enums/integrationEnums';

type FreddieMacUnderwriteFormValues = Record<string, never>;

interface EditFreddieMacUnderwriteIntegrationSettingsProps {
  onCancel: () => void;
  onSave?: (_settings: IntegrationSettings) => void;
  integrationSettings?: IntegrationSettings;
  environment: string;
}

export const EditFreddieMacUnderwriteIntegrationSettings = ({
  onCancel,
  onSave,
  integrationSettings,
  environment,
}: EditFreddieMacUnderwriteIntegrationSettingsProps): JSX.Element => {
  const isEditMode = !!integrationSettings;

  const validationSchema = yup.object().shape({});

  const { handleSubmit } = useForm<FreddieMacUnderwriteFormValues>({
    defaultValues: {},
    resolver: yupResolver(validationSchema),
    mode: 'onSubmit',
  });

  return (
    <div className="surface-section p-4 border-1 surface-border border-round mb-3">
      <h3 className="mt-0 mb-3">
        {isEditMode ? 'Edit Freddie Mac Underwrite Settings' : 'Freddie Mac Underwrite Settings'}
      </h3>
      <form
        autoComplete="off"
        onSubmit={handleSubmit((data) => {
          console.log('Form validated successfully:', data);

          if (onSave) {
            let settings: IntegrationSettings;

            if (isEditMode && integrationSettings) {
              settings = {
                ...integrationSettings,
                vendor: IntegrationVendor.FreddieMac,
                environment: environment,
                integrationData: JSON.stringify({}),
              };
            } else {
              settings = {
                name: 'Freddie Mac Underwrite Integration',
                vendor: IntegrationVendor.FreddieMac,
                status: IntegrationStatus.Active,
                environment: environment,
                integrationData: JSON.stringify({}),
              };
            }

            onSave(settings);
          }
        })}
        noValidate
        className="pb-3 p-fluid p-input-filled"
      >
        <div className="flex justify-content-end gap-2 mt-4" style={{ zIndex: 1000 }}>
          <Button
            type="button"
            label="Cancel"
            className="p-button p-button-outlined"
            style={{ width: 'auto', minWidth: 'auto' }}
            onClick={onCancel}
          />
          <Button
            type="submit"
            label={isEditMode ? 'Update' : 'Save'}
            className="p-button"
            style={{ width: 'auto', minWidth: 'auto' }}
          />
        </div>
      </form>
    </div>
  );
};
